<template>
  <div>
    <div class="breadcrumb">
      <!-- <h1 v-if="detail.status_id != 10" style="color: #AC8400;">Claim Details: {{ detail.status.name }}</h1> -->
      <!-- <h1 v-else style="color: #AC8400;">Claim Details: Pending Document Submission</h1> -->
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBK</b> /

      <router-link to="/tbk_claim">
        Claims
      </router-link>
      /

      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-2 ml-1">
      <p v-if="detail.status_id != 10" style="margin-right: 20px;">
        <b>Officer:</b> {{ detail.staff.user.name }}
      </p>
      <p v-if="detail.status_id != 10" style="margin-right: 20px;">
        <b>Date Taken:</b> {{ detail.counter_date | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 6" style="margin-right: 20px;">
        <b>Date Completed:</b> {{ detail.updated_at | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 6" style="margin-right: 20px;">
        <b>Status:</b> {{ detail.status.name }}
      </p>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 card">
        <div class="tab-content" id="myTabContent">
          <!-- Participant Details -->
          <div class="row">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
              Participant Details
            </div>

            <div class="col-md-6">
              <p><b>Name:</b> {{ profile.full_name }}</p>

              <p><b>IC No.:</b> {{ detail.user.ic_number }}</p>

              <p>
                <b>Date of Birth:</b>
                {{ profile.date_of_birth | moment("Do MMMM YYYY") }}
              </p>

              <div>
                <p><b>Gender:</b> {{ profile.gender }}</p>
              </div>

              <div>
                <p><b>Marital Status:</b> {{ profile.marital_status }}</p>
              </div>

              <p><b>Nationality:</b> {{ profile.nationality }}</p>

              <!-- <p>
              <b>Race:</b> {{ detail.race }}
            </p> -->

              <p><b>Religion:</b> {{ profile.religion }}</p>

              <p><b>Email:</b> {{ detail.user.email }}</p>
            </div>

            <div class="col-md-6">
              <!-- no longer required? -->
              <!-- <p>
              <b>Customer Code:</b> {{ detail.cfid }}
            </p> -->

              <p>
                <b>Registration Date:</b>
                {{ detail.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
              </p>

              <p><b>Occupation:</b> {{ profile.occupation }}</p>

              <p><b>Mobile No.:</b> {{ profile.mobile_number }}</p>

              <!-- <p>
              <b>Office No.:</b> {{ detail.office_number }}
            </p> -->

              <p>
                <b>Address:</b>
                <span>{{
                  profile.address1 +
                  checkNull(profile.address2) +
                  checkNull(profile.address3) +
                  checkNull(profile.kampong)
                }}</span>
              </p>

              <p><b>Postal Code:</b> {{ profile.postal_code }}</p>

              <p><b>Office Address:</b> {{ profile.office_address }}</p>
            </div>
          </div>

          <div class="mt-3 mb-4 border-top"></div>

          <!-- Claim Details -->
          <div class="row">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
              Claim Details
            </div>

            <div class="col-md-4">
              <!-- Reference ID ani apa? -->
              <p><b>Reference ID:</b> {{ detail.claim_intimation_number }}</p>

              <p><b>Product:</b> {{ detail.product.name }}</p>

              <p>
                <span v-if="detail.certificate_number != null"><b>Certificate No.:</b> {{ detail.certificate_number }}
                </span>
                <span v-else><b>Certificate No.:</b> </span>
              </p>

              <p v-if="detail.product_id == 6">
                <span v-if="meta.length > 0"><b>Person Covered:</b> {{ meta[0].meta_value }}
                </span>
                <span v-else><b>Person Covered:</b> </span>
              </p>

              <p>
                <span v-if="detail.certificate_number != null"><b>Valid From:</b>
                  {{ detail.certificate_start_date | moment("Do MMMM YYYY") }}
                </span>
                <span v-else><b>Valid From:</b> </span>
              </p>

              <p>
                <span v-if="detail.certificate_number != null"><b>Valid Until:</b>
                  {{ detail.certificate_expiry_date | moment("Do MMMM YYYY") }}
                </span>
                <span v-else><b>Valid Until:</b> </span>
              </p>
            </div>

            <div class="col-md-4">
              <p><b>Claim Type:</b> {{ detail.benefit.name }}</p>

              <p>
                <b>Incident Date:</b>
                {{ detail.incident_date | moment("Do MMMM YYYY") }}
              </p>

              <p>
                <span><b>Notification Date:</b>
                  {{ detail.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
                </span>
              </p>

              <p>
                <b>Description of loss:</b>
                <span v-if="detail.benefit.product_id == 7">
                  <span v-if="detail.benefit.id == 11">Outpatient</span>
                  <span v-if="detail.benefit.id == 12">Cancer Cover</span>
                  <span v-if="detail.benefit.id == 13">Hospital Allowance</span>
                </span>
                <span v-if="detail.benefit.product_id == 11">
                  <span v-if="detail.benefit.id == 27">Critical Illness</span>
                </span>
                <span v-if="detail.benefit.product_id == 9">
                  <span v-if="detail.benefit.id == 18">Critical Illness Coverage</span>
                </span>
                <span v-for="(loss, index) in detail.losses" v-bind:key="index">
                  <span v-if="loss.loss !== 'Others'">
                    <br />
                    - {{ loss.loss }}
                  </span>
                  <span v-else>
                    <br />
                    - Others: {{ detail.other }}
                  </span>
                </span>
              </p>

              <!-- <p>
              <b>Details: </b>
              <br>
              <span v-for="(meta, index) in metas" v-bind:key="index">
                <b>{{meta.label}}: </b> <span v-if="meta.key != 'purchase_price'"> {{meta.value | moment("Do MMMM YYYY")}} </span> <span v-else > {{meta.value}} </span> <br> 
              </span>
            </p> -->
            </div>

            <div class="col-md-4">
              <p>
                <b>Deadline to submit to Counter:</b>
                {{ detail.deadline_date | moment("Do MMMM YYYY") }}
              </p>

              <p>
                <b>Date submit form at Counter:</b>
                <datepicker format="DD/MM/YYYY" v-if="detail.status_id == 10" v-model="counter_date" width="300px">
                </datepicker>
                <span v-else>
                  {{ detail.counter_date | moment("Do MMMM YYYY") }}</span>
              </p>

              <p>
                <button class="btn btn-lg btn-success" @click="downloadZip(detail.id)">
                  Download
                </button>
              </p>
            </div>
          </div>

          <!-- CLAIM METAS -->
          <div class="col-12">
            <table class="display table table-striped table-bordered" style="width:100%; text-align: center;">
              <tr>
                <th v-for="(meta, index) in metas" v-bind:key="index">
                  {{ meta.label }}
                </th>
              </tr>
              <tr>
                <td v-for="(meta, index) in metas" v-bind:key="index">
                  <span v-if="checkUpload(meta.value)">
                    <input type="button" value="View File" class="btn btn-primary" @click="openImage(meta.id)" />
                  </span>
                  <span v-else-if="meta.key != 'purchase_price'">
                    {{ meta.value | moment("Do MMMM YYYY") }}
                  </span>
                  <span v-else> {{ meta.value }} </span>
                </td>
              </tr>
            </table>
          </div>

          <br />

          <!-- Button -->
          <div class="row">
            <div class="col-12 text-center">
              <button @click="updateCounterDate(detail.id)" class="btn btn-lg btn-success  col-3"
                v-if="detail.status_id == 10">
                Proceed
              </button>
              <button @click="proceedToProcess(detail.id)" class="btn btn-lg btn-success  col-3"
                v-else-if="detail.status_id == 4">
                Approve
              </button>
              <span class="col-3"></span>
              <button @click="reject_claim(detail.id)" class="btn btn-lg btn-danger col-3" v-if="
                detail.status_id != 6 &&
                detail.status_id != 10 &&
                detail.status_id != 7
              ">
                Reject
              </button>
            </div>
          </div>

          <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import datepicker from "vuejs-datetimepicker";
import Profile from "@/views/contents/customers/Customer_profile.vue";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  name: "tbk_claim_details",
  components: {
    datepicker,
    Profile,
    Loading
  },

  data() {
    return {
      counter_date: "",
      detail: [],
      profile: [],
      metas: [],
      isLoading: false,
      fullPage: true
    };
  },

  methods: {
    loadDetails() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tbk/claim/show/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.detail = res.data;
            if (res.data.claims_meta != null) {
              res.data.claims_meta.forEach(element => {
                this.metas.push({
                  id: element.id,
                  label: element.meta_label,
                  value: element.meta_value,
                  key: element.meta_key
                });
              });
            }

          })
          .then(() => {
            this.loadProfile(token);
          });
      }
    },

    loadProfile(token) {
      axios
        .get(
          axios.baseURL2 + "/customer?ic_number=" + this.detail.user.ic_number,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(res => {
          this.profile = res.data;
        });
    },

    proceedToProcess(detail_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/claim/approve/" + detail_id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised == false) {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                } else {
                  if (res.data.success == true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    }).then(ok => {
                      this.$router.push({ name: "tbk_claim" });
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    checkNull(string) {
      if (string == null) {
        return "";
      }
      return ", " + string;
    },

    downloadZip(claimID) {
      let token = localStorage.getItem("token");
      this.isLoading = true;
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/claims/download",
            {
              claim_id: claimID
            },
            {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            }
          )
          .then(res => {
            this.isLoading = false;
            var fileURL = window.URL.createObjectURL(new Blob([res.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "claims_" + claimID + ".zip");
            document.body.appendChild(fileLink);
            fileLink.click();
          });
      }
    },

    updateCounterDate(id) {
      let token = localStorage.getItem("token");
      if (this.counter_date === "") {
        return swal({
          icon: "error",
          text: "Please enter date submit to counter"
        });
      }

      if (!this.checkingDate()) {
        return swal({
          icon: "error",
          text: "Submit to counter date must be within notification date."
        });
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .post(
            "claim/update/" + id,
            {
              counter_date: this.changeDateFormat(this.counter_date),
              _method: "patch"
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.proceedToProcess(id);
          });
      }
    },
    /**
     * input format DD/MM/YYYY
     * output YYYY-MM-DD
     */
    changeDateFormat(date) {
      let newdate = date.split("/");

      return newdate[2] + "-" + newdate[1] + "-" + newdate[0];
    },

    reject_claim(detail_id) {
      let token = localStorage.getItem("token");

      //check if has token
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/claim/reject/" + detail_id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised == false) {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                } else {
                  if (res.data.success == true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    }).then(ok => {
                      this.$router.push({ name: "tbk_claim" });
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    checkUpload(str) {
      let type = str
        .split(".")
        .pop()
        .toLowerCase();
      if (type == "jpeg" || type == "png" || type == "jpg" || type == "pdf") {
        return true;
      }

      if (type == "mp4" || type == "mp3") {
        return undefined;
      }
    },

    openImage(id) {
      this.isLoading = true;
      let token = localStorage.getItem("token");
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .get("/download/" + id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(res => {
            this.isLoading = false;
            let type = "image/x-png, image/gif, image/jpeg, image/jpg";

            let blob = new Blob([res.data], { type: type }),
              url = window.URL.createObjectURL(blob);

            window.open(url);
          });
      }
    },

    checkingDate() {
      let counter_date = this.counter_date;
      counter_date = counter_date
        .split("/")
        .reverse()
        .join("-");

      let notification_date = moment(this.detail.created_at).format(
        "YYYY-MM-DD"
      );
      let selected = moment(counter_date).format("YYYY-MM-DD");

      if (selected < notification_date) {
        return false;
      }
      return true;
    }
  },

  mounted() {
    this.loadDetails();
  }
};
</script>
